var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-rteinput-container"},[(_vm.disabled)?_c('div',{attrs:{"id":"text-area-read-only"},domProps:{"innerHTML":_vm._s(_vm.value)}}):_c('div',{ref:"textarea",attrs:{"id":"text-area"}},[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }